module.exports = __webpack_public_path__ + "static/media/user-profile.ea052dab.svg";